import { render, staticRenderFns } from "./PossibleChildren.vue?vue&type=template&id=20818123&scoped=true&"
import script from "./PossibleChildren.vue?vue&type=script&lang=ts&"
export * from "./PossibleChildren.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20818123",
  null
  
)

export default component.exports